import { BackArrow } from 'lib/styles/icons';
import palette from 'lib/styles/palette';
import { useState } from 'react';
import styled, { css } from 'styled-components';
import { useNavigate } from 'react-router-dom';
import * as authAPI from 'lib/api/auth';
import Modal from 'components/common/Modal';

const FindIdForm = () => {
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [tel, setTel] = useState('');
  const canGoNext = name.trim() && tel.trim();
  const [error, setError] = useState('');
  const [isModal, setModal] = useState(false);
  const [id, setId] = useState('');

  const findId = async () => {
    try {
      const response = await authAPI.findId({
        name,
        tel,
      });
      setId(response.data.userId);
      setError('');
      setModal(true);
    } catch (e) {
      setError(e.response.data.msg);
    }
  };

  const onChangeTel = e => {
    const value = e.target.value.replaceAll('-', '');
    setTel(value);
  };

  const onChangeName = e => {
    setName(e.target.value);
  };

  return (
    <Background>
      {isModal && (
        <Modal>
          <Box style={{ width: 300 }}>
            <div style={{ fontWeight: 'bold' }}>아이디: {id}</div>
            <StyledButton
              style={{ width: 100, marginTop: 30 }}
              canGoNext
              onClick={() => navigate('/')}
            >
              확인
            </StyledButton>
          </Box>
        </Modal>
      )}
      <Box>
        <div className="top-wrapper">
          <div className="title">아이디 찾기</div>
          <BackArrow className="back-arrow" onClick={() => navigate(-1)} />
        </div>
        <StyledInput
          type="text"
          placeholder="이름을 입력하세요"
          autoFocus
          onChange={onChangeName}
        />
        <StyledInput
          type="tel"
          placeholder="휴대폰 번호를 입력하세요"
          onChange={onChangeTel}
        />
        {error && <div className="error">{error}</div>}
        <StyledButton
          canGoNext={canGoNext}
          disabled={!canGoNext}
          onClick={findId}
        >
          확인
        </StyledButton>
      </Box>
    </Background>
  );
};

export default FindIdForm;

const Background = styled.div`
  height: 100%;
  background-color: ${palette.background};
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Box = styled.div`
  width: 500px;
  padding: 40px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  border: solid 1px rgba(0, 0, 0, 0.08);
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.5);
  box-shadow: 0 0 50px 0 rgba(0, 0, 0, 0.04);

  .top-wrapper {
    position: relative;
    display: flex;
    align-items: center;
    height: 100%;
    margin-bottom: 30px;

    .title {
      font-size: 22px;
      font-weight: bold;
    }

    .back-arrow {
      position: absolute;
      left: 180px;
      font-size: 20px;
    }
  }

  .error {
    margin-top: 10px;
    color: red;
    font-size: 14px;
  }
`;

const StyledInput = styled.input`
  width: 330px;
  height: 50px;
  border-radius: 11px;
  border: solid 1px #dfdfdf;
  background: #fff;
  padding: 15px;
  font-size: 16px;
  &::placeholder {
    color: #c6c6c6;
  }
  & + & {
    margin-top: 15px;
  }
`;

const StyledButton = styled.button`
  width: 330px;
  height: 40px;
  margin-top: 15px;
  border: none;
  border-radius: 8px;
  color: white;
  cursor: pointer;
  ${props =>
    props.canGoNext
      ? css`
          background: ${palette.theme[2]};
          &:hover {
            background: ${palette.theme[3]};
          }
        `
      : css`
          background: ${palette.theme[0]};
        `}
`;
